import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = { class: "max-w-7xl mx-auto sm:px-6 lg:px-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl font-extrabold tracking-tight text-black text-center" }, " Orders ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "mt-3 text-xl text-gray-500 text-center" }, " All our recent orders. Stale orders will be archived after 7 days. ", -1)
const _hoisted_5 = { class: "px-4 py-8 sm:px-0" }

import { useOrders } from "@/composables/orders";
import { useSupplier } from "@/composables/supplier";
import OrdersTable from "@/components/OrdersTable.vue";
import { round } from "lodash";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { orders: allOrders } = useOrders();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", null, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("section", _hoisted_5, [
          _createVNode(OrdersTable)
        ])
      ])
    ])
  ]))
}
}

})